export default {
    state: {
        nameApp: 'ACES',
        version: '0.0.1',
        environments: [
            {
                name: 'development',
                url: 'http://localhost:8000/',
                urlApiBackend: 'http://10.10.38.43:8000/api/',
                urlSocketIO: 'http://10.10.38.43:3000/',
                urlWebSocketFacturacionCl: 'ws://localhost:8005',
                urlImagen: 'https://isystem4.aceschile.cl/img/'
            },
            {
                name: 'production',
                url: 'https://api.isystem4.aceschile.cl/',
                urlApiBackend: 'https://api.isystem4.aceschile.cl/api/',
                urlSocketIO: 'http://10.10.38.43:3000/',
                urlWebSocketFacturacionCl: 'ws://localhost:8005',
                urlImagen: 'https://isystem4.aceschile.cl/img/'
            },
        ],
        headers: {
			Accept: 'application/json',
			Authorization: ''
		},
    },
    mutations: {
        setHeadersAuthorization(state, token) { state.headers.Authorization = 'Bearer ' + token },
    },
    getters: { 
        getEnvironment() {
            return process.env.NODE_ENV
        },
        getEnvironmentCurrent() {
            let environment = process.env.NODE_ENV
            if(environment == 'development') {
                environment = (localStorage.getItem('environment') != null) ? localStorage.getItem('environment') : environment
            }
            return environment
        },
        getApiBackend: (state, getters) => {
            let environment = getters.getEnvironmentCurrent
            let index = state.environments.map((el) => el.name).indexOf(environment)
            index = (index == -1) ? 0 : index
            return state.environments[index].urlApiBackend
        },
        getHeaders: state => { return state.headers },
        getNameApp: state => { return state.nameApp },
        getUrl: (state, getters) => {
            let environment = getters.getEnvironmentCurrent
            let index = state.environments.map((el) => el.name).indexOf(environment)
            index = (index == -1) ? 0 : index
            return state.environments[index].url
        },
        getUrl_back: state => {
            let environment = 'development'
            if(process.env.NODE_ENV == environment) {
                environment = (localStorage.getItem('environment') != null) ? localStorage.getItem('environment') : environment
            }
            let index = state.environments.map((el) => el.name).indexOf(environment)
            index = (index == -1) ? 0 : index
            return state.environments[index].url
        },
        getUrlSocketIO: state => {
            let environment = 'development'
            if(process.env.NODE_ENV == environment) {
                environment = (localStorage.getItem('environment') != null) ? localStorage.getItem('environment') : environment
            }
            let index = state.environments.map((el) => el.name).indexOf(environment)
            index = (index == -1) ? 0 : index
            return state.environments[index].urlSocketIO
        },
        getUrlImagen: state => {
            let environment = 'development'
            if(process.env.NODE_ENV == environment) {
                environment = (localStorage.getItem('environment') != null) ? localStorage.getItem('environment') : environment
            }
            let index = state.environments.map((el) => el.name).indexOf(environment)
            index = (index == -1) ? 0 : index
            return state.environments[index].urlImagen
        }
    },
    actions: { },
    modules: { },
  };